import React, { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { getFileUrl } from '../../lib/api';

export const HeroSliderV3 = ({ slides = [] }) => {
  const [current, setCurrent] = useState(0);
  const [isPaused, setIsPaused] = useState(false);

  const nextSlide = useCallback(() => {
    if (slides.length > 0) setCurrent(prev => (prev + 1) % slides.length);
  }, [slides.length]);

  useEffect(() => {
    if (isPaused || slides.length <= 1) return;
    const timer = setInterval(nextSlide, 6000);
    return () => clearInterval(timer);
  }, [isPaused, nextSlide, slides.length]);

  if (slides.length === 0) return <div className="w-full h-[70vh] bg-secondary flex items-center justify-center"><p className="text-muted-foreground">Slider görsel eklenmemiş</p></div>;

  const slide = slides[current];
  return (
    <div className="w-full md:h-[85vh] overflow-hidden" onMouseEnter={() => setIsPaused(true)} onMouseLeave={() => setIsPaused(false)} data-testid="home-hero-carousel-v3">
      <div className="grid grid-cols-1 md:grid-cols-2 md:h-full">
        {/* Left - Text */}
        <div className="flex flex-col justify-center px-6 sm:px-10 md:px-16 py-12 bg-[#0f1419]">
          <h1 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-white mb-4">{slide.title}</h1>
          {slide.subtitle && <p className="text-gray-300 text-base sm:text-lg mb-8 max-w-md">{slide.subtitle}</p>}
          {slide.link && <Link to={slide.link} className="inline-flex items-center self-start px-8 py-3 rounded-lg bg-[hsl(var(--gold))] text-[hsl(var(--accent-foreground))] font-medium text-sm hover:bg-[hsl(var(--gold)/0.92)] transition-colors">{slide.button_text || 'Projeyi İncele'}</Link>}
          {slides.length > 1 && <div className="flex gap-2 mt-8">{slides.map((_, i) => <button key={i} onClick={() => setCurrent(i)} className={`w-2.5 h-2.5 rounded-full transition-colors ${i === current ? 'bg-[hsl(var(--gold))]' : 'bg-white/30'}`} />)}</div>}
        </div>
        {/* Right - Image (full image on mobile, cover on desktop panel) */}
        <div className="relative md:h-full bg-[#0f1419]">
          <img src={getFileUrl(slide.image_path)} alt={slide.title} className="w-full h-auto object-contain md:h-full md:object-cover" />
          {slides.length > 1 && <>
            <button onClick={() => setCurrent(prev => (prev - 1 + slides.length) % slides.length)} className="absolute left-3 top-1/2 -translate-y-1/2 p-2 rounded-full bg-black/30 text-white hover:bg-black/50"><ChevronLeft className="w-5 h-5" /></button>
            <button onClick={nextSlide} className="absolute right-3 top-1/2 -translate-y-1/2 p-2 rounded-full bg-black/30 text-white hover:bg-black/50"><ChevronRight className="w-5 h-5" /></button>
          </>}
        </div>
      </div>
    </div>
  );
};
